import { SalesDepartment } from "@/models";
import { Component, Vue } from "vue-property-decorator";
import { camelToUnderscore } from "@/utils/Typography";

@Component({})
export default class SalesDepartmentsMixin extends Vue {
  readonly path = camelToUnderscore(SalesDepartment.type);
  readonly routes = this.$getModelRoutes(this.path);

  getSalesDepartments(data: any, tag: string) {
    const path = `${data.companyId}/${this.path}`;
    const routes = this.$getModelRoutes(path);
    return this.$httpGet(routes.indexUrl(data), tag);
  }

  getSalesDepartment(
    id: number | string,
    companyId: number | string,
    tag,
    opts?: { fields?: { [key: string]: string }; include?: string }
  ) {
    const path = `${companyId}/${this.path}`;
    const routes = this.$getModelRoutes(path);
    return this.$httpGet(routes.getUrl(id, opts), tag);
  }
}
